export const GTM_ID_8847 = import.meta.env.VITE_GTM_ID_8847 ?? '';
export const ENVIRONMENT = import.meta.env.VITE_ENV ?? 'development';
export const CMS_API_URL = import.meta.env.VITE_CMS_API;
export const OMEGA_API_URL = import.meta.env.VITE_OMEGA_API;
export const PAYMENT_GATEWAY_URL = import.meta.env.VITE_PAYMENT_GATEWAY_URL;
export const BRAND_ID = import.meta.env.VITE_BRAND_ID ?? 1;